import {SelectField} from "./select";
import {FieldControl} from "@signature-it/ngx-generic/enums";

export class SlideToggleField extends SelectField {
	controlType = FieldControl.SLIDE_TOGGLE;
    constructor(options: {} = {}) {
        super(options);
		this.controlType = FieldControl.SLIDE_TOGGLE;
		this.dynamicOptions = this.type === 'Yes/No' ? false : true;
    }
}
